var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .Delete_a {\n                fill: #fff;\n                opacity: 0;\n            }\n\n            .Delete_b {\n                fill: #304669;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1806 -299)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "Delete_a",
    width: 24,
    height: 24,
    transform: "translate(1806 299)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2068 546.228)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Delete_b",
    d: "M-240.871-241.775h-5.18a3.453,3.453,0,0,0-3.453-3.453,3.453,3.453,0,0,0-3.453,3.453h-5.18a.863.863,0,0,0-.863.863.863.863,0,0,0,.863.863h.863v13.814a1.728,1.728,0,0,0,1.728,1.728h12.088a1.728,1.728,0,0,0,1.728-1.728v-13.811h.863a.863.863,0,0,0,.863-.863.864.864,0,0,0-.865-.865ZM-249.5-243.5a1.729,1.729,0,0,1,1.728,1.728h-3.455A1.729,1.729,0,0,1-249.5-243.5Zm6.043,17.266h-12.086v-13.814h12.088v13.814Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Delete_b",
    d: "M-78.939,47.167a.863.863,0,0,0,.863-.863V39.4a.863.863,0,0,0-.863-.863.863.863,0,0,0-.863.863V46.3a.86.86,0,0,0,.863.863Zm3.453,0a.863.863,0,0,0,.863-.863V39.4a.863.863,0,0,0-.863-.863.863.863,0,0,0-.863.863V46.3a.863.863,0,0,0,.863.863Zm3.453,0a.863.863,0,0,0,.863-.863V39.4a.863.863,0,0,0-.863-.863.863.863,0,0,0-.863.863V46.3a.863.863,0,0,0,.863.863Zm0,0",
    transform: "translate(-174.018 -275.559)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.625f83d114a956be1585bc57d6f9c8a9.svg";
export { ForwardRef as ReactComponent };